import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import TotalSales_MonthWise from '../../../../assets/images/TotalSales(MonthWise).png';
import { managementFinanceAPI } from "../../../../api/managementFinanceAPI";
import TotalSales from "../../../chart/managementFinanceChart/totalSales_MonthWiseChart/totalSales_MonthWiseChart";
import AllPcode from "../../../allPcode";
import './custom.css';
import usePcode from "../../../../common/hooks/usePcode";


dayjs.extend(utc);
dayjs.extend(advancedFormat);

export default function TotalSales_MonthWiseModal() {

    const [year, setYear] = useState(new Date().getFullYear());
    const [data, setData] = useState([]);
    const [isFetching, setIsFetching] = useState(false);
    const [showChart, setShowChart] = useState(false);
    const { loggedPcode } = usePcode();
    const [selectedPcode, setSelectedPcode] = useState(loggedPcode);


    // Initialize data for each year
    const yearData = {};

    const handleYearDateChange = (value) => {
        const selectedDate = value; // Get the selected date from the input

        // Extract the year part from the selected date
        const parsedDate = new Date(selectedDate);
        const year = parsedDate.getFullYear(); // Get the year from the date

        setYear(year); // Update the state with the extracted year as an integer
    };

    var years = [year, year - 1];

    const handleData = (selectedPcode, year) => {
        if (year === undefined) { toast.warn("Please select month"); return; }

        setIsFetching(true);

        managementFinanceAPI.getTotalSales(year, selectedPcode).then((data) => {
            setData(data);
            setIsFetching(false);
        }).catch((e) => {
            setIsFetching(false);
            toast.error(e.message);
        });
    }

    const chartData = [['Month', year.toString(), (year - 1).toString()]];

    years.forEach(year => {
        yearData[year] = {};
    });

    // Process the data to populate yearData
    data.forEach(item => {
        const currentYear = item.year;
        if (years.includes(currentYear)) {
            if (!yearData[currentYear]) {
                yearData[currentYear] = {};
            }
            yearData[currentYear][item.month] = item.netTotal;
        }
    });

    // Fill in missing months with 0 net total
    years.forEach(year => {
        for (let month = 1; month <= 12; month++) {
            if (!yearData[year][month]) {
                yearData[year][month] = 0;
            }
        }
    });

    // Convert yearData to chartData format
    for (let month = 1; month <= 12; month++) {
        const monthName = new Date(year, month - 1, 1).toLocaleString('default', { month: 'short' });
        const row = [monthName];
        years.forEach(year => {
            row.push(yearData[year][month]);
        });
        chartData.push(row);
    }

    useEffect(() => {
        handleData(selectedPcode, year);
    }, [selectedPcode, year]);

    useEffect(() => {
        const handleShowChart = () => {
            setShowChart(true);
        };

        const modalElement = document.getElementById("TotalSales");
        if (modalElement) {
            modalElement.addEventListener("shown.bs.modal", handleShowChart);
        }

        return () => {
            if (modalElement) {
                modalElement.removeEventListener("shown.bs.modal", handleShowChart);
            }
        };
    }, []);


    return (
        <>
            <a type="button" className='border border-0 rounded rounded-5' data-bs-toggle="modal" data-bs-target="#TotalSales">
                <img src={TotalSales_MonthWise} className="card-img-top rounded rounded-5" alt="TotalSales" />
            </a>
            <div className="modal fade" id="TotalSales" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-sm">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Total Sales (Month Wise)</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body w-100 h-100 bg-light">
                            <div className="row">
                                <div className="col-0 col-sm-0 col-md-0 col-lg-8 col-xl-8 col-xxl-8">
                                    <div className="input-group input-group-sm">
                                        <AllPcode setSelectedPcode={setSelectedPcode} loggedPcode={loggedPcode} />
                                    </div>
                                </div>
                                <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 col-xxl-4" >
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            views={['year']}
                                            value={year ? dayjs(new Date(year, 1, 1)) : null}
                                            onChange={(val) => handleYearDateChange(val)}
                                            slotProps={{
                                                textField: {
                                                    className: 'custom-datepicker',
                                                },
                                            }}
                                        />
                                    </LocalizationProvider>
                                </div>
                                <TotalSales data={chartData} loading={isFetching} showChart={showChart} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}